import React, { useEffect, useState } from "react";

import SiteAlertTypes from "./SiteAlertTypes";
import SiteAlertEscalation from "./SiteAlertEscolation";
import { URL } from "../../../Services/Constant";
import { get, post } from "../../../Services/ApiHandler";

const SiteAlertMain = () => {
  const [site, setSite] = useState([]);
  const [siteList, setSiteList] = useState([]);
  const [alertData, setAlertData] = useState([]);
  const [alertDatas, setAlertDatas] = useState([]);
  const user_details = JSON.parse(localStorage.getItem("user_details"));

  const [activeTab, setActiveTab] = useState("types");

  useEffect(() => {
    const stored = localStorage.getItem("types");
    if (stored) {
      setActiveTab(JSON.parse(stored));
    } else {
      setActiveTab("types");
      localStorage.setItem("types", JSON.stringify("types"));
    }
  }, []);

  const handleTab = (type) => {
    setActiveTab(type);
    localStorage.setItem("types", JSON.stringify(type));
    setSite([]);
  };

  const getAlert = () => {
    let formdata = new FormData();
    formdata.append("site_id", user_details?.knf_company_site_id);
    post(URL.SITE_ALERT_TYPES_LIST, formdata)
      .then((res) => {
        if (res?.lists?.length > 0) {
          setAlertData(res?.lists);
        } else {
          setAlertData([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getAlertEsculation = () => {
    let formdata = new FormData();
    formdata.append("site_id", user_details?.knf_company_site_id);
    post(URL.SITE_ALERT_ESCULATION_LIST, formdata)
      .then((res) => {
        if (res?.lists?.length > 0) {
          setAlertDatas(res?.lists);
        } else {
          setAlertDatas([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getAlert();
    getAlertEsculation();
  }, []);

  return (
    <div className="dashRightView">
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "types" ? "active" : ""}`}
          onClick={() => handleTab("types")}
        >
          Alert Types
        </button>
        <button
          className={`tab-btn ${activeTab === "escalation" ? "active" : ""}`}
          onClick={() => handleTab("escalation")}
        >
          Alert Escalation Time
        </button>
      </div>

      <div>
        {activeTab === "types" && (
          <SiteAlertTypes
            alertData={alertData}
            setAlertData={setAlertData}
            getAlert={getAlert}
          />
        )}
        {activeTab === "escalation" && (
          <SiteAlertEscalation
            alertDatas={alertDatas}
            setAlertDatas={setAlertDatas}
            getAlertEsculation={getAlertEsculation}
          />
        )}
      </div>
    </div>
  );
};

export default SiteAlertMain;
